import addMount from "../../../core/addMount";
import ReservationList from "./reservation-list.entry";

addMount({ appName: "reservation-list", app: ReservationList });
